export default "__VITE_ASSET__Bd9x$$oV__"